// @flow
import * as api from "../data/firebase-data";
import * as actionTypes from "../constants/action-types";

/** EXAMPLE ACTIONS

 ***ASYNC EXAMPLE:

 export const doSomeAction = (foo): (any => void) => {
    function thunk(dispatch) {
        someAsyncFunction(foo)
            .then((result: mixed) => {
                dispatch({ type: actionTypes.SOME_ACTION_SUCCESS, payload: {result}});
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.SOME_ACTION_FAIL, payload: {error} });
            });
    }
    thunk.interceptOnOffline = true;
    return thunk;
};


 ***SYNCHRONOUS EXAMPLE:

 export const soSomeAction = (api: DataType): ActionType => (
 {
        type: actionTypes.SOME_ACTION,
        api
    }
 );

 **/

export const clearError = () => ({ type: actionTypes.CLEAR_TOOLS_ERROR });


export const queryTowns = (): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        return api.queryTowns({})
            .then((data: mixed) => {
                dispatch({ type: actionTypes.QUERY_TOWNS_SUCCESS, payload: data });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.QUERY_TOWNS_FAIL, payload: { error } });

            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};

export const queryTrashCollectionlSites = (): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        return api.apiGetTrashCollectionSites({})
            .then((data: mixed) => {
                dispatch({ type: actionTypes.QUERY_TRASH_COLLECTION_SITES_SUCCESS, payload: data });

            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.QUERY_TRASH_COLLECTION_SITES_FAIL, payload: { error: error.message } });
            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};

export const querySupplyDistributionSites = (): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        return api.apiGetSupplyDistributionSites({})
            .then((data: mixed) => {
                dispatch({ type: actionTypes.QUERY_SUPPLY_DISTRIBUTION_SITES_SUCCESS, payload: data });

            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.QUERY_SUPPLY_DISTRIBUTION_SITES_FAIL, payload: { error: error.message } });

            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};

export const queryCelebrations = (): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        return api.apiGetCelebrations({})
            .then((data: mixed) => {
                dispatch({ type: actionTypes.QUERY_CELEBRATIONS_SUCCESS, payload: data });

            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.QUERY_CELEBRATIONS_FAIL, payload: { error: error.message } });

            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};


export const queryFAQs = (): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        return api.apiGetFAQs({})
            .then((data: mixed) => {
                dispatch({ type: actionTypes.QUERY_FAQS_SUCCESS, payload: data });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.QUERY_FAQS_FAIL, payload: { error } });

            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};


export const restoreTownData = (backupData): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        const towns = JSON.parse(backupData);
        return api.apiSetTowns(towns)
            .then((data: mixed) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_SUCCESS, payload: { data, collection: "TOWNS" } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_FAIL, payload: { error: error.message } });
            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};

export const restoreTrashCollectionSiteData = (backupData): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        const trashCollectionSites = JSON.parse(backupData);
        return api.apiSetTrashCollectionSites(trashCollectionSites)
            .then((data: mixed) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_SUCCESS, payload: { data, collection: "TRASH_COLLECTION" } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_FAIL, payload: { error: error.message } });
            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};

export const restoreSupplyDistributionSiteData = (backupData): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        const supplyDistributionSites = JSON.parse(backupData);
        return api.setSupplyDistributionSites(supplyDistributionSites)
            .then((data: mixed) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_SUCCESS, payload: { data, collection: "SUPPLIES" } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_FAIL, payload: { error: error.message } });
            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};

export const restoreCelebrationsData = (backupData): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        const celebrations = JSON.parse(backupData);
        return api.apiSetCelebrations(celebrations)
            .then((data: mixed) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_SUCCESS, payload: { data, collection: "CELEBRATIONS" } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_FAIL, payload: { error: error.message } });
            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};


export const restoreFAQSData = (backupData): (any => void) => {
    function thunk(dispatch) {
        dispatch({ type: actionTypes.IS_BUSY });
        const faqs = JSON.parse(backupData);
        return api.apiSetFAQs(faqs)
            .then((data: mixed) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_SUCCESS, payload: { data, collection: "FAQS" } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.BACKUP_RESTORE_FAIL, payload: { error: error.message } });
            });
    }

    thunk.interceptOnOffline = false;
    return thunk;
};
